import React, { useState } from "react";
import "./qualify.css";

export default function Qualification() {
  const [togglequal, Togglechange] = useState(1);

  return (
    <section className="qualification section" id="portfolio">
      <h2 className="section__title">Qualification</h2>
      <span className="section__subtitle">My personel Journey</span>

      <div className="qualification__container container">
        <div className="qualification__tabs">
          <div
            className={
              togglequal === 1
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex"
            }
            onClick={() => Togglechange(1)}
          >
            <i className="uil uil-graduation-cap">Education</i>
          </div>
          <div
            className={
              togglequal === 2
                ? "qualification__button qualification__active button--flex"
                : "qualification__button button--flex"
            }
            onClick={() => Togglechange(2)}
          >
            <i className="uil uil-briefcase-alt">Experience</i>
          </div>
        </div>
        <div className="qualification__sections">
          <div
            className={
              togglequal === 1
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Secondary School</h3>
                <span className="qualification__subtitle">
                  Completed in C.E.O.A Matriculation School with 97.6%{" "}
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i> 2013-2015
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">Higher Secondary</h3>
                <span className="qualification__subtitle">
                  Completed in C.E.O.A Matriculation Higher Secondary School
                  with 89.75%
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i> 2015-2017
                </div>
              </div>
            </div>
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">
                  Bachelor's Degree (CSE)
                </h3>
                <span className="qualification__subtitle">
                  Completed in PSG Insititue of Technology & Applied Research
                  with 8.2 GPA
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i> 2017-2021
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
            {/* <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">Snow dev</h3>
                <span className="qualification__subtitle">Spain</span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i> 2021-present
                </div>
              </div>
            </div> */}
          </div>
          <div
            className={
              togglequal === 2
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Associate Analyst</h3>
                <span className="qualification__subtitle">Aspire Systems</span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i> 2021-2024
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
            <div className="qualification__data">
              <div></div>
              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
              <div>
                <h3 className="qualification__title">Analyst</h3>
                <span className="qualification__subtitle">
                  Deloitte - LON(Onsite)
                </span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i> 2024(Sep)-2024(Aug)
                </div>
              </div>
            </div>
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Analyst</h3>
                <span className="qualification__subtitle">Deloitte</span>
                <div className="qualification__calendar">
                  <i className="uil uil-calendar-alt"></i> Present
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
